import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import { useAuthState } from '../../../../../../Helper/Context';
import { useDispatch } from 'react-redux';
import moment from 'moment'
import { WaterQuantityPostDataAPI } from '../../../../../../Redux/WaterSupplyDashBoardSlice/PreventiveWorkWaterSupply/WaterQuantitySlice';

export default function WaterQuantityPreventiveWorkPopup(props) {

    const { RoleID, handleOnCloseClick, open, Flag, handleIsPost, apiFlag, rowData, DashProjectTypeId } = props

    // const [rowData, setRowData] = useState(Flag === 'Update' ? rowData : '')

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [WaterQuantityField, setWaterQuantityField] = useState({
        readingDate: Flag === 'Update' ? moment(rowData.readingDate).format("YYYY-MM-DD") : '',
        wardName: Flag === 'Update' ? rowData.wardName : '',
        junctionDetails: Flag === 'Update' ? rowData.junctionDetails : '',
        locationDetails: Flag === 'Update' ? rowData.locationDetails : '',
        pipelineDetails: Flag === 'Update' ? rowData.pipelineDetails : '',
        yesterdayReading: Flag === 'Update' ? rowData.yesterdayReading : '',
        todayReading: Flag === 'Update' ? rowData.todayReading : '',
        incomingFinalReading: Flag === 'Update' ? rowData.incomingFinalReading : '',
        incomingInitialReading: Flag === 'Update' ? rowData.incomingInitialReading : '',
        outgoingInitialReading: Flag === 'Update' ? rowData.outgoingInitialReading : '',
        outgoingFinalReading: Flag === 'Update' ? rowData.outgoingFinalReading : '',
    })

    const handleWaterQuantityField = (e) => {
        setWaterQuantityField({ ...WaterQuantityField, [e.target.name]: e.target.value })
    }

    const handleClear = () => {
        // setIsClear(!IsClear)

        setWaterQuantityField({
            wardName: '',
            locationDetails: '',
            junctionDetails: '',
            pipelineDetails: '',
            yesterdayReading: '',
            outgoingInitialReading: '',
            outgoingFinalReading: '',
            incomingFinalReading: '',
            incomingInitialReading: '',
        })
    }
    const handlePost = () => {
        const data = {
            T_TTP_WaterQualityID: Flag === 'Update' ? rowData.t_TTP_WaterQualityID : '0',
            T_WS_WaterMainLineQuantityID: Flag === 'Update' ? rowData.t_wS_WaterMainLineQuantityID : '0',
            T_Distri_WS_WaterQuantityID: Flag === 'Update' ? rowData.t_Distri_WS_WaterQuantityID : '0',
            IncomingFinalReading: WaterQuantityField.incomingFinalReading,
            OutgoingFinalReading: WaterQuantityField.outgoingFinalReading,
            TodaysReading: WaterQuantityField.todayReading,
            M_UserID: UserID,
            token: token,
            Flag: Flag === 'Update' ? 'Update' : 'Insert',
            handleIsPost: handleIsPost,
            handleOnCloseClick: handleOnCloseClick,
            DashProjectTypeId: DashProjectTypeId,
            RoleID: RoleID
        }
        dispatch(WaterQuantityPostDataAPI({ data }))
    }



    const [IsOpen, setIsOpen] = useState(false)


    const [WardName, setWardName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [LocationName, setLocationName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [PipeSize, setPipeSize] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [IncomingYesterdayReading, setIncomingYesterdayReading] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [OutgoingYesterdayReading, setOutgoingYesterdayReading] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    return (
        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="water_pop modal-dialog modal-dialog-scrollable modal-xl">
                <div className="modal-content">
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">Water Quantity</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>

                    <div className="modal-body">
                        <div className='inner-modal-body'>

                            <div className="row details-row">

                                <div className=" col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Date </b></label>
                                        <input type="date" className="form-control"
                                            name='readingDate'
                                            id="readingDate"
                                            value={WaterQuantityField.readingDate}
                                            onChange={(e) => handleWaterQuantityField(e)}
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 col-lg-6" >
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Ward Name </b></label>
                                        <input type="text" className="form-control"
                                            id="wardName"
                                            name='wardName'
                                            value={WaterQuantityField.wardName}
                                            onChange={(e) => handleWaterQuantityField(e)}
                                        />
                                    </div>
                                </div>
                                {
                                    (DashProjectTypeId == '6' && RoleID != '16') ?
                                        <div className="col-12 col-md-6 col-lg-6" >
                                            <div className="form-group">
                                                <label className="d-block" htmlFor="NameofDepartment"><b>Location Name </b></label>
                                                <input type="text" className="form-control"
                                                    id="locationDetails"
                                                    name='locationDetails'
                                                    value={WaterQuantityField.locationDetails}
                                                    onChange={(e) => handleWaterQuantityField(e)}
                                                />
                                            </div>
                                        </div>
                                        :
                                        <div className="col-12 col-md-6 col-lg-6" >
                                            <div className="form-group">
                                                <label className="d-block" htmlFor="NameofDepartment"><b>Junction Name </b></label>
                                                <input type="text" className="form-control"
                                                    id="junctionDetails"
                                                    name='junctionDetails'
                                                    value={WaterQuantityField.junctionDetails}
                                                    onChange={(e) => handleWaterQuantityField(e)}
                                                />
                                            </div>
                                        </div>
                                }

                                <div className="col-12 col-md-6 col-lg-6" >
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Pipe Size </b></label>
                                        <input type="text" className="form-control"
                                            id="pipelineDetails"
                                            name='pipelineDetails'
                                            value={WaterQuantityField.pipelineDetails}
                                            onChange={(e) => handleWaterQuantityField(e)}
                                        />
                                    </div>
                                </div>

                                {
                                    (DashProjectTypeId == '6' && RoleID != '16') ?
                                        <>
                                            <div className="col-12 col-md-6 col-lg-6" >
                                                <div className="form-group">
                                                    <label className="d-block" htmlFor="NameofDepartment"><b>Incoming Yesterday Reading </b></label>
                                                    <input type="text" className="form-control"
                                                        id="incomingInitialReading"
                                                        name='incomingInitialReading'
                                                        aria-describedby="emailHelp"
                                                        value={WaterQuantityField.incomingInitialReading}
                                                        onChange={(e) => handleWaterQuantityField(e)}
                                                    />

                                                </div>

                                            </div>
                                            <div className=" col-12 col-md-6 col-lg-6">
                                                <div className="form-group">
                                                    <label className="d-block" htmlFor="NameofDepartment"><b>Today's Reading </b></label>
                                                    <input type="text" className="form-control"
                                                        id="incomingFinalReading"
                                                        name='incomingFinalReading'
                                                        value={WaterQuantityField.incomingFinalReading}
                                                        onChange={(e) => handleWaterQuantityField(e)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6 col-lg-6" >
                                                <div className="form-group">
                                                    <label className="d-block" htmlFor="NameofDepartment"><b>Outgoing Yesterday Reading </b></label>
                                                    <input type="text" className="form-control"
                                                        id="outgoingInitialReading"
                                                        name='outgoingInitialReading'
                                                        aria-describedby="emailHelp"
                                                        value={WaterQuantityField.outgoingInitialReading}
                                                        onChange={(e) => handleWaterQuantityField(e)}
                                                    />

                                                </div>
                                            </div>

                                            <div className=" col-12 col-md-6 col-lg-6">
                                                <div className="form-group">
                                                    <label className="d-block" htmlFor="NameofDepartment"><b>Today's Reading </b></label>
                                                    <input type="text" className="form-control"
                                                        id="outgoingFinalReading"
                                                        name='outgoingFinalReading'
                                                        value={WaterQuantityField.outgoingFinalReading}
                                                        onChange={(e) => handleWaterQuantityField(e)}
                                                    />
                                                </div>
                                            </div>

                                        </>
                                        :
                                        <>
                                            <div className="col-12 col-md-6 col-lg-6" >
                                                <div className="form-group">
                                                    <label className="d-block" htmlFor="NameofDepartment"><b> Yesterday Reading </b></label>
                                                    <input type="text" className="form-control"
                                                        id="yesterdayReading"
                                                        name='yesterdayReading'
                                                        aria-describedby="emailHelp"
                                                        value={WaterQuantityField.yesterdayReading}
                                                        onChange={(e) => handleWaterQuantityField(e)}
                                                    />

                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6 col-lg-6" >
                                                <div className="form-group">
                                                    <label className="d-block" htmlFor="NameofDepartment"><b>Today's Reading </b></label>
                                                    <input type="text" className="form-control"
                                                        id="todayReading"
                                                        name='todayReading'
                                                        aria-describedby="emailHelp"
                                                        value={WaterQuantityField.todayReading}
                                                        onChange={(e) => handleWaterQuantityField(e)}
                                                    />

                                                </div>
                                            </div>

                                        </>
                                }


                            </div>
                            <div className="col-12 col-lg-12">
                                <div className="btn-action d-flex justify-content-end mt-lg-3">
                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => (handlePost(), handleClear())}
                                    >{Flag === "Update" ? "Update" : "Save"} </button>
                                    <button type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* )} */}
        </Popup>
    )

}